import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { type GenericOutageBannerSeverity } from "@src/appV2/FeatureFlags/CbhFeatureFlags";
import { isEmpty } from "lodash";

type UseOutageBannerResult =
  | {
      isVisible: true;
      data: {
        severity: GenericOutageBannerSeverity;
        title: string;
        body: string;
      };
    }
  | { isVisible: false; data: null };

export function useOutageBanner(): UseOutageBannerResult {
  const outageBannerValues = useCbhFlag(CbhFeatureFlag.ADMIN_APP_GENERIC_OUTAGE_BANNER, {
    defaultValue: {},
  });

  if (isEmpty(outageBannerValues)) {
    return { isVisible: false, data: null };
  }

  const { severity, title, body } = outageBannerValues as {
    severity: GenericOutageBannerSeverity;
    title: string;
    body: string;
  };

  return { isVisible: true, data: { severity, title, body } };
}
